/**
 * objToList
 * @param {*} obj 
 * @param {*} keyName 
 */
export const objToList = function (obj, keyName, format) {
    return Object.keys(obj).map(key => {
        return {
            ...obj[key],
            [keyName]: format ? format(key) : key
        }
    })
};

/**
 * listToObj
 * @param {*} list 
 * @param {*} keyName 
 */
 export const listToObj = function (list, keyName = 'id', format) {
    let res = {}
    list.forEach(item => {
        res[item[keyName]] = format && format(item) || item
    })

    return res
};

/**
 * 重写obj key
 * @param {*} obj 
 * @param {*} keys 
 */
export const objRenameKey = function (obj, keys, _default = 0) {
    obj && Object.keys(keys).forEach(oldKey => {
        typeof(obj[oldKey]) !== "undefined" ? delete Object.assign(obj, {
            [keys[oldKey]]: obj[oldKey]
        })[oldKey] : Object.assign(obj, {
            [keys[oldKey]]: obj[keys[oldKey]] || _default
        });
    })

    return obj
};

/**
 * 重写 objarr key
 * @param {*} arr 
 * @param {*} keys 
 */
export const arrRenameKey = function (arr, keys) {
    return arr.map(item => {
        return objRenameKey(item, keys)
    })
};

const randomString = () => Math.random().toString(16).substr(2)
export const getUniqueKey = () => randomString() + randomString() + randomString() + randomString()

export function debounce (fn, wait) {
    var timer = null
    return function () {
        var context = this
        var args = arguments
        if (timer) {
            clearTimeout(timer)
            timer = null
        }
        timer = setTimeout(function () {
            fn.apply(context, args)
        }, wait)
    }
}

export function throttle (fn, gapTime) {
    let _lastTime = null

    return function () {
        const context = this
        const args = arguments
        let _nowTime = new Date()
        if (_nowTime - _lastTime > gapTime || !_lastTime) {
            fn.apply(context, args)
            _lastTime = _nowTime
        }
    }
}

export const getGbLen = (string = '') => {
    let len = 0
    for (let i = 0; i < string.length; i++) {
        const charCode = string.charCodeAt(i)
        if (charCode > 127 || charCode === 94) {
            len += 2
        } else {
            len++
        }
    }
    return len
}

// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
export const DateFormat = function (date, fmt) {
    var o = {
        "M+": new Date(date).getMonth() + 1, //月份
        "d+": new Date(date).getDate(), //日
        "h+": new Date(date).getHours(), //小时
        "m+": new Date(date).getMinutes(), //分
        "s+": new Date(date).getSeconds(), //秒
        "q+": Math.floor((new Date(date).getMonth() + 3) / 3), //季度
        "S": new Date(date).getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (new Date(date).getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}
